export class FeedbackData {
  petId!: string;
  customerId!: string;
  treatmentId!: string;
}
